import React from "react";
import "./AboutPage.css";

import about1 from "../../Assets/About/about-1.jpg";
import about2 from "../../Assets/About/about-2.jpg";

import Services from "../../Components/Home/Services/Services";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

import brand1 from "../../Assets/Brands/brand1.webp";
import brand2 from "../../Assets/Brands/brand2.avif";
import brand4 from "../../Assets/Brands/brand4.avif";
import brand6 from "../../Assets/Brands/brand6.webp";
import brand7 from "../../Assets/Brands/brand7.webp";
import brand10 from "../../Assets/Brands/brand10.png";
import brand11 from "../../Assets/Brands/brand11.png";
import brand12 from "../../Assets/Brands/brand12.png";
import brand13 from "../../Assets/Brands/brand13.png";
import brand14 from "../../Assets/Brands/brand14.png";
import brand16 from "../../Assets/Brands/brand16.jpg";
import brand17 from "../../Assets/Brands/brand17.jfif";
import brand18 from "../../Assets/Brands/brand18.png";
import brand19 from "../../Assets/Brands/brand19.png";
import brand20 from "../../Assets/Brands/brand20.png";
import brand21 from "../../Assets/Brands/brand21.png";
import brand23 from "../../Assets/Brands/brand23.jpg";

const AboutPage = () => {
  return (
    <>
      <div className="aboutSection">
        <h2>O Alpha Focus</h2>
        <img src="imgs/banner.png" alt="" />
        <div className="aboutContent">
          <h3>Naša priča</h3>
          <p>
            👁️ Alpha-Focus – briga o vašem vidu na najvišem nivou.
            <br /><br />
            Ponosni smo što je u našem timu dr. Senad Selimović, primarijus i specijalista oftalmologije, te što našim klijentima pružamo stručne oftalmološke preglede uz savremenu dijagnostičku opremu.
            Stručnost, iskustvo i posvećenost pacijentu temelj su našeg rada, jer zdravlje vaših očiju nema cijenu.
            <br /><br />
            📍 Posjetite Alpha-Focus i povjerite svoj vid provjerenim stručnjacima.
            Alpha-Focus – fokus na vaš vid. 👓✨
          </p>
        </div>
      </div>
      <Services />
      <div className="companyPartners">
        <h5>Naši partneri</h5>
        <Swiper
          slidesPerView={1}
          loop={true}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 5,
            },

            768: {
              slidesPerView: 4,
              spaceBetween: 40,
            },

            1024: {
              slidesPerView: 5,
              spaceBetween: 50,
            },
          }}
          spaceBetween={10}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
        >
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand1} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand2} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand4} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand10} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand11} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand12} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand13} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand14} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand16} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand17} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand18} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand19} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand20} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand21} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand23} alt="" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </>
  );
};

export default AboutPage;
